module.exports = __webpack_public_path__ + "img/2-37-1.19bc8df6.png";